module.exports = __webpack_public_path__ + "fonts/sourcesansprobold.bceacce1.woff2";